import styled from "@emotion/styled";
import { getSupportedUserLanguage } from "src/lib/i18next";
import { getHeadingProps, useFocusHeading } from "src/lib/useFocusHeading";
import { KnownProgram } from "src/constants/programs";
import AppointmentsList from "src/ui/components/AppointmentsList/AppointmentsList";
import Branding from "src/ui/components/Branding/Branding";
import DailyReadingsWidget from "src/ui/components/DailyReadings/DailyReadingsWidget";
import MealInsightUploadCard from "src/ui/components/MealInsights/MealInsightUploadCard";
import PoweredByWidget from "src/ui/components/PoweredByWidget/PoweredByWidget";
import RxDietCard from "src/ui/components/RxDiet/RxDietCard";
import CollectionTitle from "src/ui/components/StyledComponents/CollectionTitle";
import TaskList from "src/ui/components/TaskList/TaskList";
import Translate from "src/ui/components/Translate/Translate";
import UserEducationalFeed from "src/ui/components/UserEducationalFeed/UserEducationalFeed";
import UserEducationalFeedOld from "src/ui/components/UserEducationalFeed/UserEducationalFeedOld";

const Wrap = styled.div`
  label: HomePageWrap;
  height: 100%;
`;

const Widgets = styled.div`
  position: relative;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
`;

const HomePage = () => {
  const { headingRef } = useFocusHeading();
  const language = getSupportedUserLanguage();

  return (
    <Wrap>
      <h1 className="only-sr" ref={headingRef} {...getHeadingProps()}>
        <Translate msg="homePage" />
      </h1>
      <Widgets>
        <PoweredByWidget />
        <DailyReadingsWidget />
      </Widgets>

      <Branding
        style={{
          marginBlockEnd: "1.6em"
        }}
      />

      <AppointmentsList />

      <TaskList
        programs={[
          KnownProgram.ONBOARDING,
          KnownProgram.CARE,
          KnownProgram.MEAL_PLAN,
          KnownProgram.LIFEBALANCE,
          KnownProgram.BEHAVIORAL_HEALTH_SCREENING,
          KnownProgram.EDUCATION,
          KnownProgram.NUTRITION_JOURNEY,
          KnownProgram.MINDSET_JOURNEY,
          KnownProgram.PHYSICAL_ACTIVITY_JOURNEY,
          KnownProgram.EVERYDAY_DIABETES_JOURNEY
        ]}
        consolidateOnboardingTasks
      />

      <MealInsightUploadCard />

      <RxDietCard />

      <nine-spacer s="md" />
      <CollectionTitle>
        <Translate msg="articles.title" />
      </CollectionTitle>
      {language === "es" ? <UserEducationalFeedOld /> : <UserEducationalFeed />}
    </Wrap>
  );
};

export default HomePage;
